<div class="read_receipt_container">
    <div>
        <img class="read_receipt_icon" [src]="state[messageStatus]">
    </div>
</div>
